import { render } from "./DeclaredPrice.svg?vue&type=template&id=36d5057a"
const script = {}
script.render = render

export default script